module["exports"] = [
  "??# #??",
  "??## #??",
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_GB/address/postcode.js
// module id = 1156
// module chunks = 1